export const RESIDENT_OPTION_LABEL = "I'm a Resident";
